import React from 'react';
import PropTypes from 'prop-types';
import Portal from '@rsos/base-components/Portal';
import {
  ResultsContainer,
  ResultWrapper,
  OptionCategory,
  SearchOption,
  SearchAbbrev,
} from './AdvancedSearchOptions.styles';

const AdvancedSearchOptions = ({
  availableSearchOptions = [],
  onSearchTypeChange,
  closeDropdown,
  top = 0,
  left = 0,
  width = 264,
}) => {
  const handleOnClick = searchType => {
    onSearchTypeChange(searchType);
    closeDropdown();
  };

  const dropdownWidth = Math.max(width, 264);

  return (
    <Portal id="advanced-search-options-portal" priority={2}>
      <ResultsContainer top={top} left={left} width={dropdownWidth}>
        <OptionCategory>ADDITIONAL DATA SEARCH</OptionCategory>
        {availableSearchOptions.map((option, idx) => (
          <ResultWrapper
            p={10}
            key={idx}
            horizontal
            ref={el => {
              // Using native DOM event (onclick) instead of React's synthetic event system
              // as a workaround because this portal is rendered outside the main React tree
              // and normal React event handling doesn't propagate correctly
              if (el) {
                el.onclick = () => handleOnClick(option.prefix);
              }
            }}
          >
            <SearchOption>{option.name}</SearchOption>
            <SearchAbbrev>{option.prefix}</SearchAbbrev>
          </ResultWrapper>
        ))}
      </ResultsContainer>
    </Portal>
  );
};

AdvancedSearchOptions.propTypes = {
  onSearchTypeChange: PropTypes.func.isRequired,
  top: PropTypes.number,
  left: PropTypes.number,
  width: PropTypes.number,
};

export default AdvancedSearchOptions;
